module.exports = __webpack_public_path__ + "assets/img/delete.39299123.png";